/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseEingabelisteFeldGroesse } from './DatabaseEingabelisteFeldGroesse';
import {
    DatabaseEingabelisteFeldGroesseFromJSON,
    DatabaseEingabelisteFeldGroesseFromJSONTyped,
    DatabaseEingabelisteFeldGroesseToJSON,
} from './DatabaseEingabelisteFeldGroesse';
import type { DatabaseEingabelisteHinzufuegen } from './DatabaseEingabelisteHinzufuegen';
import {
    DatabaseEingabelisteHinzufuegenFromJSON,
    DatabaseEingabelisteHinzufuegenFromJSONTyped,
    DatabaseEingabelisteHinzufuegenToJSON,
} from './DatabaseEingabelisteHinzufuegen';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';
import type { DatabaseHeaderBlock } from './DatabaseHeaderBlock';
import {
    DatabaseHeaderBlockFromJSON,
    DatabaseHeaderBlockFromJSONTyped,
    DatabaseHeaderBlockToJSON,
} from './DatabaseHeaderBlock';
import type { DatabaseHeaderBlockActionType } from './DatabaseHeaderBlockActionType';
import {
    DatabaseHeaderBlockActionTypeFromJSON,
    DatabaseHeaderBlockActionTypeFromJSONTyped,
    DatabaseHeaderBlockActionTypeToJSON,
} from './DatabaseHeaderBlockActionType';

/**
 * 
 * @export
 * @interface DatabaseEingabelisteHeaderBlock
 */
export interface DatabaseEingabelisteHeaderBlock extends DatabaseHeaderBlock {
    /**
     * Die Unterdatenbank, aus der die Zeilen kommen.
     * @type {string}
     * @memberof DatabaseEingabelisteHeaderBlock
     */
    childDatabaseId?: string;
    /**
     * Das Datenfeld, das je Zeile eingetragen wird — bei der
     * Minigolfkarte der Name des Spielers.
     * @type {string}
     * @memberof DatabaseEingabelisteHeaderBlock
     */
    feldId?: string;
    /**
     * Mengenvorgabe: hoechstens so viele Zeilen. 0 oder leer heisst ohne
     * Grenze.
     * @type {number}
     * @memberof DatabaseEingabelisteHeaderBlock
     */
    menge?: number;
    /**
     * 
     * @type {DatabaseEingabelisteHinzufuegen}
     * @memberof DatabaseEingabelisteHeaderBlock
     */
    hinzufuegen?: DatabaseEingabelisteHinzufuegen;
    /**
     * Ein Kreuz je Zeile; fragt vor dem Loeschen nach.
     * @type {boolean}
     * @memberof DatabaseEingabelisteHeaderBlock
     */
    loeschenErlaubt?: boolean;
    /**
     * Eine leere Zeile steht von Anfang an da, statt erst auf Knopfdruck
     * zu erscheinen.
     * @type {boolean}
     * @memberof DatabaseEingabelisteHeaderBlock
     */
    erstesFeldGeoeffnet?: boolean;
    /**
     * Der graue Text in der leeren Zeile, etwa „Spieler eintragen".
     * @type {string}
     * @memberof DatabaseEingabelisteHeaderBlock
     */
    platzhalter?: string;
    /**
     * 
     * @type {DatabaseEingabelisteFeldGroesse}
     * @memberof DatabaseEingabelisteHeaderBlock
     */
    feldGroesse?: DatabaseEingabelisteFeldGroesse;
    /**
     * Nur bei `feldGroesse: MIT_RAND`: um wie viele Pixel das Feld AN
     * JEDER SEITE gekuerzt wird (Betreiber 16.09.2026: „Besser als %
     * waeren Pixel, die man eintragen kann. … Dies wird an jeder Seite
     * gekuerzt.").
     * 
     * Ohne Angabe (oder 0) steht das Feld wie bei KOMPLETT.
     * @type {number}
     * @memberof DatabaseEingabelisteHeaderBlock
     */
    randBreite?: number;
    /**
     * 
     * @type {string}
     * @memberof DatabaseEingabelisteHeaderBlock
     */
    schriftart?: string;
    /**
     * Mit Einheit, etwa „14px".
     * @type {string}
     * @memberof DatabaseEingabelisteHeaderBlock
     */
    schriftgroesse?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseEingabelisteHeaderBlock
     */
    schriftfarbe?: string;
    /**
     * Hintergrund des EINGABEFELDES, nicht des Bausteins.
     * @type {string}
     * @memberof DatabaseEingabelisteHeaderBlock
     */
    hintergrund?: string;
    /**
     * Rahmen des Eingabefeldes in Pixeln; 0 heisst kein Rahmen.
     * @type {number}
     * @memberof DatabaseEingabelisteHeaderBlock
     */
    rahmenBreite?: number;
    /**
     * Abrundung des Eingabefeldes in Pixeln.
     * @type {number}
     * @memberof DatabaseEingabelisteHeaderBlock
     */
    rahmenRundung?: number;
    /**
     * 
     * @type {string}
     * @memberof DatabaseEingabelisteHeaderBlock
     */
    rahmenFarbe?: string;
}

/**
 * Check if a given object implements the DatabaseEingabelisteHeaderBlock interface.
 */
export function instanceOfDatabaseEingabelisteHeaderBlock(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseEingabelisteHeaderBlockFromJSON(json: any): DatabaseEingabelisteHeaderBlock {
    return DatabaseEingabelisteHeaderBlockFromJSONTyped(json, false);
}

export function DatabaseEingabelisteHeaderBlockFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseEingabelisteHeaderBlock {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...DatabaseHeaderBlockFromJSONTyped(json, ignoreDiscriminator),
        'childDatabaseId': !exists(json, 'childDatabaseId') ? undefined : json['childDatabaseId'],
        'feldId': !exists(json, 'feldId') ? undefined : json['feldId'],
        'menge': !exists(json, 'menge') ? undefined : json['menge'],
        'hinzufuegen': !exists(json, 'hinzufuegen') ? undefined : DatabaseEingabelisteHinzufuegenFromJSON(json['hinzufuegen']),
        'loeschenErlaubt': !exists(json, 'loeschenErlaubt') ? undefined : json['loeschenErlaubt'],
        'erstesFeldGeoeffnet': !exists(json, 'erstesFeldGeoeffnet') ? undefined : json['erstesFeldGeoeffnet'],
        'platzhalter': !exists(json, 'platzhalter') ? undefined : json['platzhalter'],
        'feldGroesse': !exists(json, 'feldGroesse') ? undefined : DatabaseEingabelisteFeldGroesseFromJSON(json['feldGroesse']),
        'randBreite': !exists(json, 'randBreite') ? undefined : json['randBreite'],
        'schriftart': !exists(json, 'schriftart') ? undefined : json['schriftart'],
        'schriftgroesse': !exists(json, 'schriftgroesse') ? undefined : json['schriftgroesse'],
        'schriftfarbe': !exists(json, 'schriftfarbe') ? undefined : json['schriftfarbe'],
        'hintergrund': !exists(json, 'hintergrund') ? undefined : json['hintergrund'],
        'rahmenBreite': !exists(json, 'rahmenBreite') ? undefined : json['rahmenBreite'],
        'rahmenRundung': !exists(json, 'rahmenRundung') ? undefined : json['rahmenRundung'],
        'rahmenFarbe': !exists(json, 'rahmenFarbe') ? undefined : json['rahmenFarbe'],
    };
}

export function DatabaseEingabelisteHeaderBlockToJSON(value?: DatabaseEingabelisteHeaderBlock | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...DatabaseHeaderBlockToJSON(value),
        'childDatabaseId': value.childDatabaseId,
        'feldId': value.feldId,
        'menge': value.menge,
        'hinzufuegen': DatabaseEingabelisteHinzufuegenToJSON(value.hinzufuegen),
        'loeschenErlaubt': value.loeschenErlaubt,
        'erstesFeldGeoeffnet': value.erstesFeldGeoeffnet,
        'platzhalter': value.platzhalter,
        'feldGroesse': DatabaseEingabelisteFeldGroesseToJSON(value.feldGroesse),
        'randBreite': value.randBreite,
        'schriftart': value.schriftart,
        'schriftgroesse': value.schriftgroesse,
        'schriftfarbe': value.schriftfarbe,
        'hintergrund': value.hintergrund,
        'rahmenBreite': value.rahmenBreite,
        'rahmenRundung': value.rahmenRundung,
        'rahmenFarbe': value.rahmenFarbe,
    };
}

